// src/routes/SuperAdmin.jsx
import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext'; // ajuste o caminho se necessário

export function SuperAdmin({ children }) {
  const { user, loadingAuth } = useContext(AuthContext);

  // Aguarda carregar o usuário antes de decidir
  if (loadingAuth) return null; // ou um <Spinner />

  if (!user || user.role !== 'SUPERADMIN') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
